import { LocalStorageKey } from 'hooks/local-storage/local-storage-key';
import { useMemo, useState } from 'react';
import { BannerCache } from 'features/banner/model/banner-cache';
import { BannerStore } from 'features/banner/model/banner';
import { useLocalStorage } from 'hooks/local-storage/useLocalStorage';
import { useLocation } from 'react-router';

export const useDismissBanner = (banner: BannerStore) => {
    const { setItem, getItem } = useLocalStorage<BannerCache[]>();
    const { pathname } = useLocation();
    const [dismissedBanners, setDismissedBanners] = useState<BannerCache[]>(
        getItem(LocalStorageKey.DISMISSED_BANNER) ?? []
    );

    const path = useMemo(() => pathname.split('/')?.[1] ?? pathname, [pathname]);

    const onDismiss = () => {
        const dismissed = getItem(LocalStorageKey.DISMISSED_BANNER) || [];
        const newDismissed = dismissed.concat([{ key: banner.key, date: new Date(), position: banner.position, path }]);
        setDismissedBanners(newDismissed);
        setItem(LocalStorageKey.DISMISSED_BANNER, newDismissed);
    };

    const isDissmissed = useMemo(
        () =>
            !!banner &&
            dismissedBanners?.some((b) => b.key === banner.key && b.position === banner.position && b.path === path),
        [banner, dismissedBanners]
    );

    return {
        onDismiss,
        dismissedBanners,
        isDissmissed,
    };
};
